export const fontsPtSerif = [
  {
    style: "normal",
    urlSet: [
      {
        format: "truetype",
        url: "/fonts/PTSerif-Regular.ttf",
      },
    ],
    weight: "400",
  },

  {
    style: "italic",
    urlSet: [
      {
        format: "truetype",
        url: "/fonts/PTSerif-RegularItalic.ttf",
      },
    ],
    weight: "400",
  },

  {
    style: "normal",
    urlSet: [
      {
        format: "truetype",
        url: "/fonts/PTSerif-Bold.ttf",
      },
    ],
    weight: "700",
  },

  {
    style: "italic",
    urlSet: [
      {
        format: "truetype",
        url: "/fonts/PTSerif-BoldItalic.ttf",
      },
    ],
    weight: "700",
  },
];
